<section class="news_Sention">
    <div class="container">
        <div class="mews_SecHead">
            <h2>{{ 'SETTING_PAGE.IDMS_SETTINGS.NEWS_UPDATES' | transloco }}</h2>
            <p>
                {{ 'HOME_PAGE.GENERAL_TEXT.NEWS_DESCRIPTION' | transloco }}
            </p>
        </div>
        <div class="inner_news">
            <div class="row">
                <div class="col-sm-6 col-lg-4" *ngFor="let newsUpdate of sharedContentsList">
                    <div class="news_wrap">
                        <div class="news_box">
                            <div class="news_img">
                                <a href="{{ newsUpdate.navigationLink }}" target="_blank"><img [src]="newsUpdate.image" /></a>

                                <span>{{ newsUpdate.sharedContentType.value }}</span>
                            </div>
                            <div class="news_content">
                                <h4>
                                    <a href="{{ newsUpdate.navigationLink }}" target="_blank">{{ newsUpdate.heading }}</a>
                                </h4>
                                <p>
                                    {{ newsUpdate.subHeading }}
                                </p>
                                <div class="calender">
                                    <span><i class="fa fa-calendar"></i> {{ newsUpdate.date | customDateTimeFormat }}</span>
                                    <a href="{{ newsUpdate.navigationLink }}" target="_blank">{{ newsUpdate.heading }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="read_more">
                            <a href="{{ newsUpdate.navigationLink }}" target="_blank" class="btn primary-ebtn btn-full-width">{{
                                newsUpdate.navigationText
                            }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="load-more" *ngIf="isLoadMoreButton">
            <a role="button" (click)="loadMore()" class="btn primary-ebtn"
                >{{ 'HOME_PAGE.BUTTONS_TEXT.LOAD_MORE' | transloco }}<i class="fa fa-long-arrow-right"></i
            ></a>
        </div>
    </div>
</section>
